import { render, staticRenderFns } from "./OrderManagementAddNote.vue?vue&type=template&id=8ff33f5a&scoped=true&"
import script from "./OrderManagementAddNote.vue?vue&type=script&lang=js&"
export * from "./OrderManagementAddNote.vue?vue&type=script&lang=js&"
import style0 from "./OrderManagementAddNote.vue?vue&type=style&index=0&id=8ff33f5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff33f5a",
  null
  
)

export default component.exports